import { formatCurrency } from '../blocos/tipos';
import type { DadosInicio } from './useDadosInicio';
import { CardBento, Rotulo, Sub, ValorGrande } from './ui';
import { useMascara } from '../../valores-ocultos/contexto';

/**
 * Em andamento — a caixinha que junta "Propostas em aberto" e "Aguardando
 * pagamento" (duas caixas e duas listas do desenho antigo) desde o v3: cada
 * linha é um clique pra página que tem a lista de verdade. É o padrão do
 * redesenho: o Início mostra o número, a página mostra os nomes.
 */
export const CardEmAndamento = ({
  data,
  managedNote,
  navigate,
}: {
  data: DadosInicio;
  managedNote: (total: number, own: number) => string | undefined;
  navigate: (to: string) => void;
}) => {
  const m = useMascara();
  const nota = managedNote(data.propostasCount, data.propostasOwnCount);
  return (
    <CardBento>
      <Rotulo>Em andamento</Rotulo>
      <button
        type="button"
        onClick={() => navigate('/propostas')}
        className="block cursor-pointer text-left"
      >
        <ValorGrande unidade=" propostas">{m(data.propostasCount)}</ValorGrande>
        <Sub className="!mt-1">
          <span className="font-semibold text-primary">abertas →</span>
          {nota ? ` · ${m(nota)}` : ''}
        </Sub>
      </button>
      <button
        type="button"
        onClick={() => navigate('/vendas?tab=pending')}
        className="mt-1.5 block cursor-pointer text-left"
      >
        <Sub className="!mt-0">
          <span className="font-semibold tabular-nums text-foreground">{m(data.pendingCount)}</span>{' '}
          aguardando pagamento
          {data.pendingValor > 0 ? (
            <>
              {' · '}
              <span className="font-semibold text-primary">
                {m(formatCurrency(data.pendingValor, true))} →
              </span>
            </>
          ) : null}
        </Sub>
      </button>
    </CardBento>
  );
};
